import { render, staticRenderFns } from "./Finalshippingmark.vue?vue&type=template&id=fd28e602&scoped=true&"
import script from "./Finalshippingmark.vue?vue&type=script&lang=js&"
export * from "./Finalshippingmark.vue?vue&type=script&lang=js&"
import style0 from "./Finalshippingmark.vue?vue&type=style&index=0&id=fd28e602&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd28e602",
  null
  
)

export default component.exports